import ServiceBase from '../../ServiceBase';
import prospectProxy from './../../../proxies/market/market-in-depth/ProspectProxy';

class ProspectService extends ServiceBase {
  getListProSpect(params) {
    return this.applyMemoryCache('ProspectService.getListProSpect', params)(
      () => prospectProxy.getListProSpect(params),
    );
  }

  getListProSpectV2(params) {
    return this.applyMemoryCache('ProspectService.getListProSpectV2', params)(
      () => prospectProxy.getListProSpectV2(params),
    );
  }
}

const prospectService = new ProspectService();
export default prospectService;
